// TOP検索バー下のキーワードチップ（PdM選定の通年キーワード。表示順）
export const TOP_KEYWORD_CHIPS = [
  'giftee Box',
  'カタログギフト',
  'スターバックス',
  '誕生日',
  'ミスタードーナツ'
]
